import { useDetailRedirect } from "~/components/blocks/product/hooks/use-detail-redirect";
import { DetailProductStore } from "~/components/stores/detail-product";
import { DialogStore } from "~/components/templates/common/dialog";
import { PurchaseModal } from "~/components/templates/common/purchase-modal";
import { ToastStore } from "~/components/templates/common/toast";

export const DetailTemplate = () => {
  const { checkingRedirect } = useDetailRedirect();

  if (checkingRedirect) return null;

  return (
    <>
      <DetailProductStore />
      <PurchaseModal />
      <ToastStore />
      <DialogStore />
    </>
  );
};
